export default __webpack_public_path__ + "static/media/icon-right-arrow.9da465d4.svg";